<template>
  <div class="BulkImportCom">
    <el-upload
      :action="`${urls}/import/import-teacher`"
      :headers="{ token: token }"
      :data="{ schoolId: schoolId }"
      :show-file-list="false"
      :on-success="uploadFIleSuccess"
    >
      <el-button size="small"><i class="el-icon-upload"></i>批量导入</el-button></el-upload
    >
  </div>
</template>

<script>
import { urls } from "@/api/home";
export default {
  name: "BulkImportCom",
  props: {
    token: {
      type: String
    },
    schoolId: {
      type: [String, Number]
    }
  },
  data() {
    return {
      urls:urls
    };
  },
  methods: {
    uploadFIleSuccess(response, file, fileList) {
      if (response.data.errorMsgs && response.data.errorMsgs.length) {
        // this.errorMsgs = response.data.errorMsgs;
        // this.flag = true;
        const h = this.$createElement;
        this.$notify.info({
          title: "提示信息",
          duration: 0,
          message: h("div", { style: { width: "500px" } }, [
            h("h4", "成功信息"),
            h("div", `成功导入${response.data.scount}信息`),
            h("h4", "错误信息"),
            h(
              "el-table",
              {
                style: {
                  width: "500px"
                },
                props: {
                  data: response.data.errorMsgs,
                  border: true,
                  width:"100",
                  height: 300
                }
              },
              [
                h("el-table-column", {
                  props: {
                    label: "错误行数",
                    prop: "row"
                  }
                }),
                h("el-table-column", {
                  props: {
                    label: "错误信息",
                    width:"399",
                    prop: "msg"
                  }
                })
              ]
            )
          ])
        });
        this.$emit("updateData");
      } else {
        this.$message.success("导入成功");
        this.$emit("updateData");
      }
    }
  }
};
</script>
<style>
.el-notification {
  width: 400px;
}
</style>



// WEBPACK FOOTER //
// src/views/school/components/components/BulkImport.vue